import React from 'react'
import { MainLayout } from './MainLayout'

export const EventsLayout = ({
  children,
  activeTab,
  isInIframe
}) => {

  return (
    <MainLayout
      activeTab={ activeTab }
      isInIframe={ isInIframe }
    >
      {children}
    </MainLayout>
  )
}
